import { useFormikContext, ErrorMessage } from 'formik';

export const FormikNumberInput = ({
  name,
  label,
  maxInteger = 3,
  maxDecimal = 2,
  maxValue = 500,
  onChangeExtra,
  className = 'form-group',
}) => {
  const { values, setFieldValue } = useFormikContext();
  const value = values[name] ?? '';

  const handleKeyDown = (e) => {
    const { value, selectionStart, selectionEnd } = e.target;

    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp',
      'ArrowDown', 'Home', 'End'
    ];

    if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;

    if (e.key === ',') {
      e.preventDefault();
      if (!value.includes('.') && selectionStart > 0) {
        const newValue = insertAtPosition(value, selectionStart, '.', selectionEnd);
        setFieldValue(name, newValue);
      }
      return;
    }

    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
      return;
    }

    if (e.key === '.' && (value.includes('.') || selectionStart === 0)) {
      e.preventDefault();
      return;
    }

    const newValue = insertAtPosition(value, selectionStart, e.key, selectionEnd);
    const [integerPart, decimalPart] = newValue.split('.');

    if (integerPart.length > maxInteger || (decimalPart && decimalPart.length > maxDecimal)) {
      e.preventDefault();
      return;
    }

    if (Number(newValue) > maxValue) {
      e.preventDefault();
      return;
    }
  };

  const handleChange = (e) => {
    let sanitizedValue = e.target.value
      .replace(/[^\d.,]/g, '')
      .replace(/,/g, '.')
      .replace(/(\..*)\./g, '$1');

    if (sanitizedValue.startsWith('.')) {
      sanitizedValue = '0' + sanitizedValue;
    }

    if (sanitizedValue === '' || isValidNumber(sanitizedValue, maxInteger, maxDecimal, maxValue)) {
      setFieldValue(name, sanitizedValue);
      if (onChangeExtra) onChangeExtra(sanitizedValue);
    }
  };

  return (
    <div className={className}>
      {label && <label htmlFor={name}>{label}</label>}
      <input
        type="text"
        name={name}
        id={name}
        value={value}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        inputMode="decimal"
      />
      <ErrorMessage name={name} component="div" className="error-message" />
    </div>
  );
};

// Funções auxiliares
function insertAtPosition(original, pos, char, endPos = pos) {
  return original.substring(0, pos) + char + original.substring(endPos);
}

function isValidNumber(value, maxInteger, maxDecimal, maxValue) {
  if (value === '' || value === '.') return false;
  const num = Number(value);
  if (isNaN(num)) return false;
  const parts = value.split('.');
  if (parts[0].length > maxInteger) return false;
  if (parts[1] && parts[1].length > maxDecimal) return false;
  if (num > maxValue) return false;
  return true;
}
